import { render } from "./Breadcrumb.vue?vue&type=template&id=0c544274&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=0c544274&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1579396552/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c544274"]])

export default __exports__